import { RootState } from '@store/rootReducer'

export const selectTemplatesSuperCategories = (state: RootState) =>
  state.editor.templates.templatesSuperCategories
export const selectTemplatesBySuperCategory = (state: RootState) =>
  state.editor.templates.templatesBySuperCategory
export const selectTemplateId = (state: RootState) => state.editor.templates.templateId
export const selectTemplateConfig = (state: RootState) => state.editor.templates.templateConfig
export const selectBackgroundActive = (state: RootState) => state.editor.templates.backgroundActive
export const selectTemplateDetails = (state: RootState) => state.editor.templates.templateDetails